<fa-icon
  [icon]="iconCircle"
  [size]="'1x'"
  class="Trigger"
  [ngClass]="{ 'Trigger-inactive': !state, 'Trigger-active': state }"
  (click)="trigger()"></fa-icon>
